module.exports = __webpack_public_path__ + "static/media/privacypolicy_tamil.e3326c90.md";